"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter.js");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _card_component = require("./global_components/card_component.js");

var _card_component2 = _interopRequireDefault(_card_component);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _reactIntl = require("react-intl");

var _currency_utility = require("../../../packages/common-utilities/src/currency_utility.js");

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _string_utility3 = require("common-utilities/src/string_utility");

var _collection_utility = require("common-utilities/src/collection_utility");

var _functional_utility3 = require("common-utilities/src/functional_utility");

var _pathSatisfies = require("ramda/src/pathSatisfies");

var _pathSatisfies2 = _interopRequireDefault(_pathSatisfies);

var _accessibility_utility = require("../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _number_utility = require("../../../packages/common-utilities/src/number_utility");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _fund_utility = require("../../../packages/common-utilities/src/fund_utility");

var _tooltipText = require("./global_components/tooltipText");

var _document_link = require("./document_link");

var _document_link2 = _interopRequireDefault(_document_link);

var _constants = require("../../../packages/common-utilities/src/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var renderDashOrValue = function renderDashOrValue(fn, value) {
  return fn(value) ? "-" : (0, _ramda.always)(value)();
};
var nullOrEmptyString = function nullOrEmptyString(value) {
  return (0, _ramda.or)((0, _ramda.equals)(value, ""), (0, _ramda.isNil)(value));
};
var isNullEmptyStringOrNA = (0, _ramda.anyPass)([nullOrEmptyString, (0, _ramda.equals)("N/A")]);
var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var renderFundFactsRow = function renderFundFactsRow(label, value, dataTest) {
  var dataTest2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var icon = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var columnLeft = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 6;
  var columnRight = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 6;

  var maxWidth = 12;
  if (columnRight === 6) {
    columnRight = maxWidth - columnLeft;
  }

  var columnLeftClassNames = "col-xs-" + columnLeft + " col-sm-" + columnLeft + " col-md-" + columnLeft + " col-lg-" + columnLeft + " col-xlg-" + columnLeft;
  var columnRightClassNames = "col-xs-" + columnRight + " col-sm-" + columnRight + " col-md-" + columnRight + " col-lg-" + columnRight + " col-xlg-" + columnRight;

  if (!(0, _ramda.isNil)(icon)) {
    return _react2.default.createElement(
      "div",
      { role: "row" },
      _react2.default.createElement(
        "span",
        {
          className: "text-left " + columnLeftClassNames + " category white-space-nowrap",
          "data-testid": dataTest2, role: "rowheader"
        },
        _react2.default.createElement(
          "span",
          { className: "white-space-default" },
          label
        ),
        "\xA0",
        icon
      ),
      _react2.default.createElement(
        "span",
        {
          className: "text-right " + columnRightClassNames + " float-right category word-wrap-break",
          "data-testid": dataTest, role: "cell"
        },
        value
      )
    );
  } else {
    return _react2.default.createElement(
      "div",
      { role: "row" },
      _react2.default.createElement(
        "span",
        { className: "text-left " + columnLeftClassNames + " category white-space-default",
          "data-testid": dataTest2, role: "rowheader"
        },
        label
      ),
      _react2.default.createElement(
        "span",
        {
          className: "text-right " + columnRightClassNames + " float-right category word-wrap-break",
          "data-testid": dataTest, role: "cell"
        },
        value
      )
    );
  }
};

var FundFactsCard = function (_React$Component) {
  _inherits(FundFactsCard, _React$Component);

  function FundFactsCard(props) {
    _classCallCheck(this, FundFactsCard);

    var _this = _possibleConstructorReturn(this, (FundFactsCard.__proto__ || Object.getPrototypeOf(FundFactsCard)).call(this, props));

    _this.renderDistributionDate = function () {
      if (isNullEmptyStringOrNA(_this.props.distributionDate)) {
        return null;
      }
      var label = _string_utility2.default.renderFormattedLabel("Distribution Date", "pdp-overview-fund-facts-distribution-date");
      var value = _this.props.distributionDate;
      return renderFundFactsRow(label, renderDashOrValue(_ramda.isNil, value), "distribution-date", "distribution-date-label");
    };

    _this.renderLiquidationDate = function () {
      var label = _string_utility2.default.renderFormattedLabel("Liquidation Date", "pdp-overview-fund-facts-liquidation-date");
      var unavailableLabel = _string_utility2.default.renderFormattedLabel("Not available", "pdp-fund-facts-distribution-liquidation-no-available");
      var value = (0, _functional_utility3.isNilOrEmpty)(_this.props.liquidationDate) ? unavailableLabel : _this.renderFormattedDate(_this.props.liquidationDate);
      return renderFundFactsRow(label, value, "liquidation-date", "liquidation-date-label");
    };

    _this.renderNewspaperShortName = function () {
      var label = _string_utility2.default.renderFormattedLabel("Newspaper Short Name", "pdp-overview-fund-facts-newspaper-shortname");
      var value = _this.props.newspaperShortName;
      return renderFundFactsRow(label, renderDashOrValue(_ramda.isNil, value), "newspaper-shortname", "newspaper-shortname-label");
    };

    _this.renderDrpDocLink = function () {
      var label = _string_utility2.default.renderFormattedLabel("Distribution Reinvestment Plan (DRP)", "pdp-fund-facts-drp-doc-link-label");
      var docList = (0, _ramda.pathOr)([], ["content", "documents", _this.props.cusip], _this.props);
      var drpDocType = _constants2.default.getFdTagConstants().DISTRIBUTION_SUPPLEMENT;
      var drpDoc = docList.filter(function (doc) {
        return doc.documentType === drpDocType;
      })[0];
      if (!drpDoc || !drpDoc.docURL) {
        return null;
      }
      var drpDocCopy = _extends({}, drpDoc, {
        title: label
      });
      var columnLeft = 7;
      var columnLeftClassNames = "font-black text-left category col-xs-" + columnLeft + " col-sm-" + columnLeft + " col-md-" + columnLeft + " col-lg-" + columnLeft + " col-xlg-" + columnLeft;
      return _react2.default.createElement(_document_link2.default, { fundDocument: drpDocCopy,
        userLoggedIn: _this.props.userLoggedIn,
        role: _this.props.role,
        basePath: _this.props.basePath,
        window: _this.props.window,
        isAEM: _this.props.isAEM,
        showDownloadIcon: true,
        textColorClass: columnLeftClassNames,
        divClass: 'margin-vertical-0',
        isLastRow: true
      });
    };

    _this.renderEsgApproach = function () {
      var esgApproachLabel = _string_utility2.default.renderFormattedLabel("ESG Approach", "pdp-overview-esg-integrated-approach-label");
      var esgApproachLabelText = _string_utility2.default.getLocalizedString(_this.props.intl, "ESG Approach", "pdp-overview-esg-integrated-approach-label");

      var _getEsgApproachInfo = (0, _fund_utility.getEsgApproachInfo)(_this.props.fund, _this.props.country),
          esgApproachWording = _getEsgApproachInfo.wording,
          disclosureId = _getEsgApproachInfo.disclosureId;

      var variedDisclosureId = (0, _ramda.includes)("ESG_VARIED_DISCLOSURE_ID", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], _this.props));
      var esgApproachDisclosureIcon = _this.renderIcon(variedDisclosureId ? disclosureId : "pdpDataPointESGApproach", esgApproachLabelText);
      if ((0, _functional_utility3.isNilOrEmpty)(esgApproachWording)) {
        return null;
      }
      return renderFundFactsRow(esgApproachLabel, esgApproachWording, "esg-approach-value", "esg-approach-label", esgApproachDisclosureIcon, 6, 6);
    };

    _this.renderSFDRClassification = function () {
      if (!_this.props.fund.sdfrClassificationValue) {
        return null;
      }
      var sfdrLabel = _string_utility2.default.renderFormattedLabel("SFDR Classification", "pdp-overview-esg-integrated-sdfr-classification-label");
      var sfdrValue = _string_utility2.default.renderFormattedLabel(_this.props.fund.sdfrClassificationValue, "esg-integrated-sfdr-" + _string_utility2.default.customKebabCase(_this.props.fund.sdfrClassificationValue));
      var sfdrText = _string_utility2.default.getLocalizedString(_this.props.intl, "SFDR Classification", "pdp-overview-esg-integrated-sdfr-classification-label");
      var sfdrDisclosureIcon = _this.renderIcon("pdpDataPointSfdrClassification", sfdrText);
      return renderFundFactsRow(sfdrLabel, sfdrValue, "sfdr-value", "sfdr-label", sfdrDisclosureIcon, 7, 5);
    };

    _this.renderUKSFDRClassification = function () {
      if ((0, _functional_utility3.isNilOrEmpty)(_this.props.isUkSDRCategorisation)) {
        return null;
      }
      var sdrLabel = _string_utility2.default.renderFormattedLabel("UK SDR Categorisation", "pdp-fund-facts-uk-sdr-categorisation");
      var sdrValue = _string_utility2.default.renderFormattedLabel(_this.props.isUkSDRCategorisation, "pdp-fund-facts-" + _string_utility2.default.customKebabCase(_this.props.isUkSDRCategorisation));
      var sdrDisclosure = _string_utility2.default.getLocalizedString(_this.props.intl, "UK SDR Categorisation", "pdp-fund-facts-uk-sdr-categorisation-disclosure");
      _this.props.disclosure['pdpDataPointUkSDRCategorization'] = [sdrDisclosure];
      var sdrDisclosureIcon = _this.renderIcon("pdpDataPointUkSDRCategorization", sdrDisclosure);
      return renderFundFactsRow(sdrLabel, sdrValue, "uk-sdr-categorisation-value", "uk-sdr-categorisation-label", sdrDisclosureIcon);
    };

    _this.renderTicker = _this.renderTicker.bind(_this);
    _this.renderExchangeTicker = _this.renderExchangeTicker.bind(_this);
    _this.renderIressTicker = _this.renderIressTicker.bind(_this);
    _this.renderListingDate = _this.renderListingDate.bind(_this);
    _this.renderAssetClass = _this.renderAssetClass.bind(_this);
    _this.renderFundInceptionDate = _this.renderFundInceptionDate.bind(_this);
    _this.renderDateOfAgreement = _this.renderDateOfAgreement.bind(_this);
    _this.renderShareClassInceptionDate = _this.renderShareClassInceptionDate.bind(_this);
    _this.renderETFInceptionDate = _this.renderETFInceptionDate.bind(_this);
    _this.renderDistributionFrequency = _this.renderDistributionFrequency.bind(_this);
    _this.renderCusip = _this.renderCusip.bind(_this);
    _this.renderIsin = _this.renderIsin.bind(_this);
    _this.renderAPIR = _this.renderAPIR.bind(_this);
    _this.renderSedolCode = _this.renderSedolCode.bind(_this);
    _this.renderRisk = _this.renderRisk.bind(_this);
    _this.renderBenchmark = _this.renderBenchmark.bind(_this);
    _this.renderShareClassCutOffTime = _this.renderShareClassCutOffTime.bind(_this);
    _this.renderFundCutOffTime = _this.renderFundCutOffTime.bind(_this);
    _this.renderShareclassNumber = _this.renderShareclassNumber.bind(_this);
    _this.renderData = _this.renderData.bind(_this);
    _this.getDisclosureTopValue = _this.getDisclosureTopValue.bind(_this);
    _this.renderIcon = _this.renderIcon.bind(_this);
    _this.renderExchange = _this.renderExchange.bind(_this);
    _this.renderReutersInstrumentCode = _this.renderReutersInstrumentCode.bind(_this);
    _this.renderVIIVTicker = _this.renderVIIVTicker.bind(_this);
    _this.renderMmfType = _this.renderMmfType.bind(_this);
    _this.renderBloomberg = _this.renderBloomberg.bind(_this);
    _this.renderRegionOfInvestment = _this.renderRegionOfInvestment.bind(_this);
    _this.renderFundCurrencyCode = _this.renderFundCurrencyCode.bind(_this);
    _this.renderShareclassCurrencyCode = _this.renderShareclassCurrencyCode.bind(_this);
    _this.renderDomicile = _this.renderDomicile.bind(_this);
    _this.renderTrustee = _this.renderTrustee.bind(_this);
    _this.renderDealing = _this.renderDealing.bind(_this);
    _this.renderYearEnd = _this.renderYearEnd.bind(_this);
    _this.renderCurrencyHedging = _this.renderCurrencyHedging.bind(_this);
    _this.renderFundValuationDate = _this.renderFundValuationDate.bind(_this);
    _this.renderShareclassSettlementDate = _this.renderShareclassSettlementDate.bind(_this);
    _this.renderFundLegalStructure = _this.renderFundLegalStructure.bind(_this);
    _this.renderCutOffTimeDisclosure = _this.renderCutOffTimeDisclosure.bind(_this);
    _this.renderRedemptionSettlementDate = _this.renderRedemptionSettlementDate.bind(_this);
    _this.renderValoren = _this.renderValoren.bind(_this);
    _this.renderWKN = _this.renderWKN.bind(_this);
    _this.renderFundCompanyName = _this.renderFundCompanyName.bind(_this);
    _this.renderOfferPrice = _this.renderOfferPrice.bind(_this);
    _this.renderCustodian = _this.renderCustodian.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    _this.renderAnnualDividend = _this.renderAnnualDividend.bind(_this);
    _this.renderActualGearing = _this.renderActualGearing.bind(_this);
    _this.renderCompanyBrokers = _this.renderCompanyBrokers.bind(_this);
    _this.renderPotentialGearingRange = _this.renderPotentialGearingRange.bind(_this);
    return _this;
  }

  _createClass(FundFactsCard, [{
    key: "doesFormattingRulesContains",
    value: function doesFormattingRulesContains(visibleDataPointName) {
      return (0, _ramda.includes)(visibleDataPointName, (0, _functional_utility.pathOrEmptyArray)(["visibleData", "formattingRules"], this.props));
    }
  }, {
    key: "renderFormattedDate",
    value: function renderFormattedDate(inputDate) {
      return _date_formatter2.default.isValidDate(inputDate) ? _date_formatter2.default.getLocalFormattedDate(inputDate) : "-";
    }
  }, {
    key: "renderFormattedHTMLLabel",
    value: function renderFormattedHTMLLabel(defaultLabel, key) {
      var fundType = this.props.fundTypeCode.replace(/\s/g, '');
      return _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: key,
        defaultMessage: defaultLabel,
        values: { fundType: fundType }
      });
    }
  }, {
    key: "renderTicker",
    value: function renderTicker() {
      if (isNullEmptyStringOrNA(this.props.ticker)) {
        return null;
      }

      var tickerLabel = _string_utility2.default.renderFormattedLabel("Ticker", "pdp-bloomberg-ticker-label", { fundType: this.props.fundTypeCode.replace(/\s/g, ''), role: this.props.role });
      return renderFundFactsRow(tickerLabel, renderDashOrValue(nullOrEmptyString, this.props.ticker), "ticker", "ticker-label");
    }
  }, {
    key: "renderIressTicker",
    value: function renderIressTicker() {
      if (isNullEmptyStringOrNA(this.props.iressTicker)) {
        return null;
      }
      var tickerLabel = _string_utility2.default.renderFormattedLabel("IRESS Ticker", "pdp-iress-ticker-label", { fundType: this.props.fundTypeCode.replace(/\s/g, ''), role: this.props.role });
      return renderFundFactsRow(tickerLabel, renderDashOrValue(nullOrEmptyString, this.props.iressTicker), "iress-ticker", "iress-ticker-label");
    }
  }, {
    key: "renderExchangeTicker",
    value: function renderExchangeTicker() {
      if (isNullEmptyStringOrNA(this.props.exchangeTicker)) {
        return null;
      }
      var tickerLabel = _string_utility2.default.renderFormattedLabel("Exchange Ticker", "pdp-exchange-ticker-label", { fundType: this.props.fundTypeCode.replace(/\s/g, ''), role: this.props.role });
      return renderFundFactsRow(tickerLabel, renderDashOrValue(nullOrEmptyString, this.props.exchangeTicker), "exchange-ticker", "exchange-ticker-label");
    }
  }, {
    key: "renderListingDate",
    value: function renderListingDate() {
      if (isNullEmptyStringOrNA(this.props.listingDate)) {
        return null;
      }
      var label = _string_utility2.default.renderFormattedLabel("Listing Date", "pdp-fund-facts-listing-date-label");
      var value = this.renderFormattedDate(this.props.listingDate);
      return renderFundFactsRow(label, value, "listing-date", "listing-date-label");
    }
  }, {
    key: "renderDomicile",
    value: function renderDomicile() {
      if (isNullEmptyStringOrNA(this.props.domicile)) {
        return null;
      }
      var domicileLabel = _string_utility2.default.renderFormattedLabel("Domicile", "pdp-overview-fund-facts-domicile-label");
      return renderFundFactsRow(domicileLabel, renderDashOrValue(nullOrEmptyString, this.props.domicile), "domicile", "domicile-label");
    }
  }, {
    key: "renderBloomberg",
    value: function renderBloomberg() {
      if (isNullEmptyStringOrNA(this.props.ticker)) {
        return null;
      }
      var bloombergLabel = _string_utility2.default.renderFormattedLabel("Bloomberg", "pdp-overview-fund-facts-bloomberg-label");
      return renderFundFactsRow(bloombergLabel, renderDashOrValue(nullOrEmptyString, this.props.ticker), "bloomberg-ticker", "bloomberg-ticker-label", null, 5, 7);
    }
  }, {
    key: "renderAssetClass",
    value: function renderAssetClass() {
      var assetClassLabel = _string_utility2.default.renderFormattedLabel("Asset Class", "pdp-asset-class-label", { role: this.props.role });
      return renderFundFactsRow(assetClassLabel, renderDashOrValue(_ramda.isNil, this.props.assetClass), "asset-class", "asset-class-label");
    }
  }, {
    key: "renderDistributionFrequency",
    value: function renderDistributionFrequency() {
      if (isNullEmptyStringOrNA(this.props.distributionFrequency)) {
        return null;
      }

      var distributionFrequencyLabel = _string_utility2.default.renderFormattedLabel("Distribution Frequency", "pdp-distribution-frequency-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      var distributionFrequencyDisplay = (0, _functional_utility.pathOrEmptyArray)(["visibleData", "formattingRules"], this.props).indexOf("DISTRIBUTION_FREQUENCY_SENTENCE_CASE") > -1 && this.props.distributionFrequency ? (0, _string_utility3.titleCase)(this.props.distributionFrequency) : this.props.distributionFrequency;

      if ("AUSTRALIA_UNIT_TRUST" === this.props.fundTypeCode || "JAPAN_INVESTMENT_TRUST" === this.props.fundTypeCode) {
        distributionFrequencyDisplay = _string_utility2.default.renderFormattedLabel(distributionFrequencyDisplay, "pdp-fund-facts-distribution-frequency-" + this.props.distributionFrequency);
        return renderFundFactsRow(distributionFrequencyLabel, renderDashOrValue(_ramda.isNil, distributionFrequencyDisplay), "distribution-frequency", "distribution-frequency-label", null, 7, 5);
      } else {
        var distributionFrequencyExpected = _string_utility2.default.renderFormattedLabel("Expected ", "pdp-distribution-frequency-expected");
        var distributionFrequency = _string_utility2.default.renderFormattedLabel((0, _string_utility3.toSentenceCase)(distributionFrequencyDisplay.toLowerCase()), "pdp-distribution-frequency-value-" + distributionFrequencyDisplay);
        var message = this.props.idExists ? _string_utility2.default.renderFormattedLabel(null, "pdp-fund-facts-distribution-frequency-" + this.props.distributionFrequency) : [distributionFrequencyExpected, distributionFrequency];
        return renderFundFactsRow(distributionFrequencyLabel, renderDashOrValue(_ramda.isNil, message), "distribution-frequency", "distribution-frequency-label", null, 7, 5);
      }
    }
  }, {
    key: "renderBenchmark",
    value: function renderBenchmark() {
      var benchmarkNameLabel = _string_utility2.default.renderFormattedLabel("Benchmark", "pdp-benchmark-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      return renderFundFactsRow(benchmarkNameLabel, renderDashOrValue(_ramda.isNil, (0, _functional_utility3.isNilOrEmpty)(this.props.benchmarkNames) ? null : this.props.benchmarkNames[0]), "benchmark", "benchmark-label", null, 5, 7);
    }
  }, {
    key: "renderRiskNumbers",
    value: function renderRiskNumbers() {
      var riskNumbers = [];
      for (var i = 1; i < 6; i++) {
        riskNumbers.push(_react2.default.createElement(
          "span",
          { "data-testid": "risk-level",
            className: "font-17 padding-left-3 " + (i === 5 && this.props.riskLevel !== 5 ? "padding-right-0" : "padding-right-3") + "\n                             " + (this.props.riskLevel === i ? " background-blue font-white height-18" : "") },
          i
        ));
      }
      return riskNumbers;
    }
  }, {
    key: "renderRisk",
    value: function renderRisk() {
      var riskLabel = _string_utility2.default.renderFormattedLabel("Risk", "pdp-risk-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      var riskLabelText = _string_utility2.default.getLocalizedString(this.props.intl, "Risk", "pdp-risk-label");

      if (_collection_utility.CollectionUtility.includes(this.props.visibleData.visibleDataPoints, 'SHOW_RISK_LEVEL_INDICATOR_IN_TRANSLATED_VALUE')) {
        if ((0, _ramda.isNil)(this.props.riskRatingValue)) {
          return null;
        }
        var riskLevelIcon = this.renderIcon("pdpDataPointRiskLevel", riskLabelText);
        return renderFundFactsRow(riskLabel, renderDashOrValue(_ramda.isNil, this.props.riskRatingValue), "risk-rating-value", "risk-label", riskLevelIcon);
      } else if (this.doesFormattingRulesContains("CA_ETF_FUND_FACTS_CARD")) {
        return renderFundFactsRow(riskLabel, renderDashOrValue(_ramda.isNil, _constants2.default.getRiskRatingLabel(this.props.riskRatingValue)), "risk-rating-value", "risk-label", null);
      } else {
        if ((0, _ramda.isNil)(this.props.riskLevel) || this.props.riskLevel === 0) {
          return null;
        }
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: "text-left col-md-6 col-lg-6 col-xlg-6 category",
              "data-testid": "risk-label" },
            riskLabel
          ),
          _react2.default.createElement(
            "span",
            { className: "text-right col-md-6 col-lg-6 col-xlg-6 float-right category" },
            this.renderRiskNumbers()
          )
        );
      }
    }
  }, {
    key: "renderRedemptionSettlementDate",
    value: function renderRedemptionSettlementDate() {
      var redemptionSettlementDateLabel = _string_utility2.default.renderFormattedLabel("Redemption Settlement Date", "pdp-redemption-settlement-date", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      return renderFundFactsRow(redemptionSettlementDateLabel, renderDashOrValue(_ramda.isNil, this.props.redemptionSettlementDate), "redemption-settlement-date", "redemption-settlement-date-label", null, 8);
    }
  }, {
    key: "renderExchange",
    value: function renderExchange() {
      if (isNullEmptyStringOrNA(this.props.tradingInfo.exchange)) {
        return null;
      }
      return renderFundFactsRow(_string_utility2.default.renderFormattedLabel("Exchange", "pdp-fund-facts-exchange-label"), renderDashOrValue(nullOrEmptyString, this.props.tradingInfo.exchange), "exchange", "exchange-label");
    }
  }, {
    key: "renderFundInceptionDate",
    value: function renderFundInceptionDate() {
      var fundInceptionDateLabel = _string_utility2.default.renderFormattedLabel("Fund Inception Date", "pdp-fund-inception-date", { fundType: this.props.fundTypeCode.replace(/\s/g, ''), role: this.props.role });
      var fundInceptionDateText = _string_utility2.default.getLocalizedString(this.props.intl, "Fund Inception Date", "pdp-fund-inception-date");
      if ((0, _ramda.includes)("ETF_INCEPTION_DATE", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleFundFacts"], this.props)) && !this.doesFormattingRulesContains("CA_ETF_FUND_FACTS_CARD")) {
        fundInceptionDateLabel = "Predecessor Mutual Fund Inception Date";
      }
      var fundInceptionDateIcon = this.renderIcon("pdpDataPointLaunchDate", fundInceptionDateText);
      var columnLeftWidth = this.doesFormattingRulesContains("EXPAND_FUND_FACTS_LABEL") ? 7 : 6;
      return renderFundFactsRow(fundInceptionDateLabel, this.renderFormattedDate(this.props.fundInceptionDate), "fund-inception-date", "fund-inception-label", fundInceptionDateIcon, columnLeftWidth);
    }
  }, {
    key: "renderDateOfAgreement",
    value: function renderDateOfAgreement() {
      var dateOfAgreementLabel = this.renderFormattedHTMLLabel("Date of agreement", "pdp-fund-date-of-agreement");
      return renderFundFactsRow(dateOfAgreementLabel, this.renderFormattedDate(this.props.dateOfAgreement), "date-of-agreement-date", "date-of-agreement-label");
    }
  }, {
    key: "renderShareClassInceptionDate",
    value: function renderShareClassInceptionDate() {
      var shareClassLabel = _react2.default.createElement(
        "span",
        { className: "white-space-default" },
        _string_utility2.default.renderFormattedLabel("Share Class Inception Date", "pdp-shareclass-inception-date", { fundType: this.props.fundTypeCode.replace(/\s/g, '') })
      );
      var columnLeftWidth = this.doesFormattingRulesContains("EXPAND_FUND_FACTS_LABEL") ? 7 : 6;
      return renderFundFactsRow(shareClassLabel, this.renderFormattedDate(this.props.shareClassInceptionDate), "share-class-inception-date", "share-class-inception-label", null, columnLeftWidth);
    }
  }, {
    key: "renderETFInceptionDate",
    value: function renderETFInceptionDate() {
      var shareClassLabel = _react2.default.createElement(
        "span",
        { className: "white-space-default" },
        "ETF Inception Date"
      );
      var columnLeftWidth = this.doesFormattingRulesContains("EXPAND_FUND_FACTS_LABEL") ? 7 : 6;
      return renderFundFactsRow(shareClassLabel, this.renderFormattedDate(this.props.shareClassInceptionDate), "share-class-etf-inception-date", "share-class-etf-inception-label", null, columnLeftWidth);
    }
  }, {
    key: "renderFundCurrencyCode",
    value: function renderFundCurrencyCode() {
      var fundCurrencyLabel = _string_utility2.default.renderFormattedLabel("Denominated Currency", "pdp-fund-facts-fund-currency-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      return renderFundFactsRow(fundCurrencyLabel, renderDashOrValue(_ramda.isNil, this.props.currencyCode), "fund-currency", "fund-currency-code-label");
    }
  }, {
    key: "renderShareclassCurrencyCode",
    value: function renderShareclassCurrencyCode() {
      var fundCurrencyLabel = _string_utility2.default.renderFormattedLabel("Share class currency", "pdp-fund-facts-shareclass-currency-label", { fundType: this.props.fundTypeCode.replace(/\s/g, ''), role: this.props.role });
      var shareclassCurrencyCode = _currency_utility2.default.getCurrencyTranslation(this.props.shareclassCurrencyCode);
      var columnLeftWidth = this.doesFormattingRulesContains("EXPAND_FUND_FACTS_LABEL") ? 8 : 6;
      return renderFundFactsRow(fundCurrencyLabel, renderDashOrValue(_ramda.isNil, shareclassCurrencyCode), "share-class-currency", "share-currency-code-label", null, columnLeftWidth);
    }
  }, {
    key: "renderCusip",
    value: function renderCusip() {
      return renderFundFactsRow("CUSIP", renderDashOrValue(_ramda.isNil, this.props.cusip), "cusip");
    }
  }, {
    key: "renderIsin",
    value: function renderIsin() {
      var isinLabel = _string_utility2.default.renderFormattedLabel("ISIN", "pdp-isin-label", { fundType: this.props.fundTypeCode.replace(/\s/g, ''), role: this.props.role });
      var isinValue = this.doesFormattingRulesContains("CA_ETF_FUND_FACTS_CARD") ? this.props.isin : this.props.cusip;
      return renderFundFactsRow(isinLabel, renderDashOrValue(_ramda.isNil, isinValue), "isin", "isin-label", null, 5, 7);
    }
  }, {
    key: "renderAPIR",
    value: function renderAPIR() {
      var apirLabel = _string_utility2.default.renderFormattedLabel("APIR", "pdp-apir-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      return renderFundFactsRow(apirLabel, renderDashOrValue(_ramda.isNil, this.props.ticker), "apir", "apir-label");
    }
  }, {
    key: "renderSedolCode",
    value: function renderSedolCode() {
      var sedolLabel = _string_utility2.default.renderFormattedLabel("SEDOL", "pdp-sedol-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      return renderFundFactsRow(sedolLabel, renderDashOrValue(_ramda.isNil, this.props.sedolCode), "sedol-code", "sedol-code-label");
    }
  }, {
    key: "renderReutersInstrumentCode",
    value: function renderReutersInstrumentCode() {
      var reutersLabel = _string_utility2.default.renderFormattedLabel("Reuters", "pdp-overview-fund-facts-reuters-label");
      return renderFundFactsRow(reutersLabel, renderDashOrValue(_ramda.isNil, this.props.reutersInstrumentCode), "reuters-instrument-code", "reuters-instrument-code-label", null, 5, 7);
    }
  }, {
    key: "renderVIIVTicker",
    value: function renderVIIVTicker() {
      var label = _string_utility2.default.renderFormattedLabel("VIIV Ticker", "pdp-viiv-ticker-label");
      var labelText = _string_utility2.default.getLocalizedString(this.props.intl, "VIIV Ticker", "pdp-viiv-ticker-label");
      var icon = this.renderIcon("pdpDataPointVIIVTicker", labelText);
      return renderFundFactsRow(label, renderDashOrValue(_ramda.isNil, this.props.viivTicker), "viiv-ticker", "viiv-ticker-label", icon);
    }
  }, {
    key: "renderRegionOfInvestment",
    value: function renderRegionOfInvestment() {
      var regionLabel = _string_utility2.default.renderFormattedLabel("Region", "pdp-overview-fund-facts-region-label");
      return renderFundFactsRow(regionLabel, renderDashOrValue(_ramda.isNil, this.props.regionOfInvestment), "region", "region-label");
    }
  }, {
    key: "renderTrustee",
    value: function renderTrustee() {
      var trusteeLabel = _string_utility2.default.renderFormattedLabel("Trustee", "pdp-trustee-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      return renderFundFactsRow(trusteeLabel, renderDashOrValue(_ramda.isNil, this.props.trustee), "trustee", "trustee-label");
    }
  }, {
    key: "renderDealing",
    value: function renderDealing() {
      var dealingLabel = _string_utility2.default.renderFormattedLabel("Dealing", "pdp-dealing-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      return renderFundFactsRow(dealingLabel, renderDashOrValue(_ramda.isNil, this.props.dealingFrequency), "dealing", "dealing-label");
    }
  }, {
    key: "renderYearEnd",
    value: function renderYearEnd() {
      var yearEndLabel = _string_utility2.default.renderFormattedLabel("Year End", "pdp-year-end-label", { fundType: this.props.fundTypeCode.replace(/\s/g, '') });
      var fiscalYearEndDate = (0, _moment2.default)(this.props.fiscalYearEnd, "DD MMMM");

      if (!fiscalYearEndDate.isValid()) {
        _moment2.default.locale("en-US");
        fiscalYearEndDate = (0, _moment2.default)(this.props.fiscalYearEnd, "DD MMMM").toDate();
        _moment2.default.locale(_string_utility2.default.generateLocale());
      } else {
        fiscalYearEndDate = fiscalYearEndDate.toDate();
      }

      return renderFundFactsRow(yearEndLabel, (0, _ramda.isNil)(this.props.fiscalYearEnd) ? "-" : _date_formatter2.default.getTranslatedDate(this.props.intl, fiscalYearEndDate, "long", "numeric"), "year-end", "year-end-label");
    }
  }, {
    key: "renderMmfType",
    value: function renderMmfType() {
      if (isNullEmptyStringOrNA(this.props.mmfType)) {
        return null;
      }
      var mmfTypeLabel = _string_utility2.default.renderFormattedLabel("MMF Type", "pdp-overview-fund-facts-mmf-type-label");
      var mmfTypeLabelText = _string_utility2.default.getLocalizedString(this.props.intl, "MMF Type", "pdp-overview-fund-facts-mmf-type-label");
      var mmfTypeIcon = this.renderIcon("pdpDataPointMMFType", mmfTypeLabelText);
      return renderFundFactsRow(mmfTypeLabel, renderDashOrValue(_ramda.isNil, this.props.mmfType), "mmf-type", "", mmfTypeIcon, 5);
    }
  }, {
    key: "renderCutOffTimeDisclosure",
    value: function renderCutOffTimeDisclosure() {
      if (!this.props.disclosure || (0, _ramda.isNil)(this.props.disclosure["pdpDataPointCutOffTime"])) {
        return null;
      }
      var length = this.props.visibleData.visibleFundFacts.length;

      for (var i = 0; i < length; i += 1) {

        if (this.props.visibleData.visibleFundFacts[i] === "SHARECLASS_CUT_OFF_TIME") {
          return _react2.default.createElement(
            "span",
            null,
            this.props.disclosure["pdpDataPointCutOffTime"]
          );
        }
      }
      return null;
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(tooltipId, ariaText) {
      var _this2 = this;

      if (!this.props.disclosure || (0, _ramda.isNil)(this.props.disclosure[tooltipId])) {
        return null;
      }

      if (this.props.useTooltipWrapper) {
        return (0, _tooltipText.getDisclaimerText)({
          className: "display-inline",
          text: _react2.default.createElement("span", {
            tabIndex: 0,
            className: "icon-info print-hide margin-left-5",
            role: "button",
            "aria-label": 'more information about' + ariaText,
            "data-testid": "fund-facts-data-disclosure-icon"
          }),
          tooltipText: this.props.disclosure[tooltipId],
          useOffsetLeftForArrowPosition: true
        });
      }

      return _react2.default.createElement(
        "span",
        { id: "disclosure-" + tooltipId, tabIndex: 0, className: "icon-info print-hide padding-left-5",
          role: "button",
          "aria-label": 'more information about' + ariaText,
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, tooltipId);
          }
        },
        " "
      );
    }
  }, {
    key: "handleDisclosureIconClick",
    value: function handleDisclosureIconClick(event, tooltipId) {
      _functional_utility2.default.handleDisclosureIconClick(this, event, tooltipId);
    }
  }, {
    key: "getIconEl",
    value: function getIconEl(tooltipId) {
      return document.getElementById("disclosure-" + tooltipId);
    }
  }, {
    key: "renderShareClassCutOffTime",
    value: function renderShareClassCutOffTime() {
      var label = _react2.default.createElement(
        "span",
        null,
        (this.props.assetClass === "Money Market" ? "Fund " : "") + " Cut-off Time"
      );
      var labelText = (this.props.assetClass === "Money Market" ? "Fund " : "") + " Cut-off Time";
      var icon = this.renderIcon("pdpDataPointCutOffTime", labelText);
      return renderFundFactsRow(label, _date_formatter2.default.convertTimeTo12HrFrom24HrFormat(this.props.shareClassCutOffTime), "share-class-cut-off-time", "", icon);
    }
  }, {
    key: "renderFundCutOffTime",
    value: function renderFundCutOffTime() {
      var label = this.renderFormattedHTMLLabel("Fund cut-off time", "pdp-overview-fund-facts-cut-off-label");
      var labelText = _string_utility2.default.getLocalizedString(this.props.intl, "Fund cut-off time", "pdp-overview-fund-facts-cut-off-label");
      var icon = this.renderIcon("pdpDataPointCutOffTime", labelText);
      var fundCutoffTimeZone = _react2.default.createElement(
        "span",
        null,
        _date_formatter2.default.getTimeInHoursAndMinutes(this.props.shareClassCutOffTime),
        " ",
        _react2.default.createElement("br", null),
        _react2.default.createElement(
          "span",
          {
            className: "font-13pt6" },
          this.props.shareClassCutOffTimeZone,
          " ",
          _string_utility2.default.renderFormattedLabel("time", "pdp-time-label")
        )
      );
      return renderFundFactsRow(label, !(0, _ramda.isNil)(this.props.shareClassCutOffTime) ? fundCutoffTimeZone : '-', "fund-cut-off-time", "fund-cut-off-time-label", icon);
    }
  }, {
    key: "renderShareclassNumber",
    value: function renderShareclassNumber() {
      var shareClassNumber = "Share Class Number";
      if (this.props.fundTypeCode === '529 Plans') {
        shareClassNumber = "Unit Class Number";
      } else if (this.props.fundTypeCode === 'Commingled') {
        shareClassNumber = "Class of Units Number";
      }
      return renderFundFactsRow(shareClassNumber, renderDashOrValue(_ramda.isNil, this.props.shareclassNumber), "shareclass-number", "shareClassLabelTxt");
    }
  }, {
    key: "renderCurrencyHedging",
    value: function renderCurrencyHedging() {
      var currencyHedgingLabel = _string_utility2.default.renderFormattedLabel("Currency hedging", "pdp-overview-fund-facts-currency-hedging-label");
      return renderFundFactsRow(currencyHedgingLabel, _string_utility2.default.getYesOrNo(this.props.hedgedShareclassIndicator), "currency-hedging", "currency-hedging-label");
    }
  }, {
    key: "renderFundValuationDate",
    value: function renderFundValuationDate() {
      var valuationDateLabel = _string_utility2.default.renderFormattedLabel("Valuation date", "pdp-overview-fund-facts-valuation-date-label");
      return renderFundFactsRow(valuationDateLabel, renderDashOrValue(_ramda.isNil, this.props.fundValuationFrequency), "fund-valuation-date", "fund-valuation-date-label");
    }
  }, {
    key: "renderShareclassSettlementDate",
    value: function renderShareclassSettlementDate() {

      var fundSettlementDateLabel = _string_utility2.default.renderFormattedLabel("Cash settlement date", "pdp-overview-fund-facts-cash-settlement-date-label");
      var fundSettlementDateLabelText = _string_utility2.default.getLocalizedString(this.props.intl, "Cash settlement date", "pdp-overview-fund-facts-cash-settlement-date-label");
      var icon = this.renderIcon("pdpDataPointCashsettlementdate", fundSettlementDateLabelText);
      return renderFundFactsRow(fundSettlementDateLabel, renderDashOrValue(_ramda.isNil, this.props.settlementCycleRedemptionName), "shareclass-settlement-date", "shareclass-settlement-date-label", icon, 7);
    }
  }, {
    key: "renderFundLegalStructure",
    value: function renderFundLegalStructure() {
      var fundLegalStructureLabel = _string_utility2.default.renderFormattedLabel("Fund legal structure", "pdp-overview-fund-facts-fund-legal-structure-label");
      return renderFundFactsRow(fundLegalStructureLabel, renderDashOrValue(_ramda.isNil, this.props.legalStructureCode), "fund-legal-structure", "fund-legal-structure-label");
    }
  }, {
    key: "renderValoren",
    value: function renderValoren() {
      var valorLabel = _string_utility2.default.renderFormattedLabel("Valor", "pdp-overview-fund-facts-valor-label");
      return nullOrEmptyString(this.props.valoren) ? null : renderFundFactsRow(valorLabel, renderDashOrValue(_ramda.isNil, this.props.valoren), "valor-value", "valor-label");
    }
  }, {
    key: "renderWKN",
    value: function renderWKN() {
      var wknLabel = _string_utility2.default.renderFormattedLabel("WKN", "pdp-overview-fund-facts-wkn-label");
      return nullOrEmptyString(this.props.wkn) ? null : renderFundFactsRow(wknLabel, renderDashOrValue(_ramda.isNil, this.props.wkn), "wkn-value", "wkn-code");
    }
  }, {
    key: "renderFundCompanyName",
    value: function renderFundCompanyName() {
      var fundCompayName = !(0, _pathSatisfies2.default)(_ramda.isNil, ["name"], this.props.fundCompany) ? this.props.fundCompany.name : null;
      var fundCompayNameLabel = _string_utility2.default.renderFormattedLabel("Umbrella name", "pdp-overview-fund-facts-fund-company-name-label");
      return renderFundFactsRow(fundCompayNameLabel, renderDashOrValue(_ramda.isNil, fundCompayName), "fund-company-name", "fund-company-name-label");
    }
  }, {
    key: "getDisclosureTopValue",
    value: function getDisclosureTopValue(topEl) {
      if (topEl.length < 1) {
        return null;
      }
      var upArrowLeftPos = (0, _jquery2.default)("#disclosure-cutOffTime").position().left;

      return {
        top: topEl.offset().top - (0, _jquery2.default)("#fund-facts-header").offset().top + 40,
        beforeArrow: upArrowLeftPos,
        afterArrow: upArrowLeftPos + 1
      };
    }
  }, {
    key: "renderOfferPrice",
    value: function renderOfferPrice() {
      var offerPriceLabel = _string_utility2.default.renderFormattedLabel("Offer Price", "pdp-fund-facts-offer-price-label");
      var offerPrice = (0, _ramda.isNil)(this.props.offerPrice) ? '-' : this.props.offerPrice;
      if (offerPrice < 0) {
        return null;
      }
      return renderFundFactsRow(offerPriceLabel, offerPrice, "offer-price", "offer-price-label");
    }
  }, {
    key: "renderCustodian",
    value: function renderCustodian() {
      var trustee = this.props.trustee;

      if ((0, _ramda.isNil)(trustee)) {
        return null;
      }

      var custodianLabel = _string_utility2.default.renderFormattedLabel("Custodian", "pdp-fund-facts-custodian-label");
      return renderFundFactsRow(custodianLabel, trustee, "custodian", "custodian-label");
    }
  }, {
    key: "renderAnnualDividend",
    value: function renderAnnualDividend() {
      var value = _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(this.props.totalAnnualDividend);
      var label = _string_utility2.default.renderFormattedLabel("Total dividend for last financial year", "pdp-fund-facts-annual-dividenf-label");
      return (0, _ramda.isNil)(value) ? null : renderFundFactsRow(label, value, "fund-stats-total-annual-dividend", "fund-stats-total-annual-dividend-label", "", 8, 4);
    }
  }, {
    key: "renderPotentialGearingRange",
    value: function renderPotentialGearingRange() {
      var value = this.props.potentialGearingRange;
      var label = _string_utility2.default.renderFormattedLabel("Potential gearing range", "pdp-fund-facts-annual-dividenf-label");
      return (0, _ramda.isNil)(value) ? null : renderFundFactsRow(label, value, "fund-stats-potential-gearing-range", "fund-stats-potential-gearing-range-label");
    }
  }, {
    key: "renderCompanyBrokers",
    value: function renderCompanyBrokers() {
      if ((0, _functional_utility3.isNilOrEmpty)(this.props.companyBrokerNames)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { className: "row padding-vertical-5" },
        _react2.default.createElement(
          "div",
          { className: "col-md-12 padding-left-0 padding-right-0 float-none" },
          _react2.default.createElement(
            "span",
            { className: "text-left col-xs-7 col-md-7 col-lg-7 col-xlg-7 category white-space-nowrap",
              "data-testid": "fund-stats-company-brokers-label",
              id: "fund-stats-company-brokers-label" },
            "Company Broker(s)"
          ),
          _react2.default.createElement(
            "span",
            { className: "text-right col-xs-5 col-md-5 col-lg-5 col-xlg-5 float-right category" },
            mapIndexed(function (companyBrokerName, i) {
              return _react2.default.createElement(
                "span",
                {
                  className: "float-right col-xs-12 col-md-12 col-lg-12 col-xlg-12 font-small font-black-variant category",
                  key: i, "data-testid": "fund-stats-company-broker-data-" + (i + 1),
                  id: "fund-stats-company-broker-data-" + (i + 1) },
                companyBrokerName
              );
            }, this.props.companyBrokerNames)
          )
        )
      );
    }
  }, {
    key: "renderActualGearing",
    value: function renderActualGearing() {
      if ((0, _ramda.isNil)(this.props.actualGearing)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col-md-12 padding-left-0 padding-right-0 float-none" },
          _react2.default.createElement(
            "span",
            {
              className: "text-left col-xs-7 col-md-7 col-lg-8 col-xlg-7 category white-space-nowrap",
              "data-testid": "fund-stats-actual-gearing-label",
              id: "fund-stats-actual-gearing-label",
              style: { zIndex: 1 }
            },
            _react2.default.createElement(
              "span",
              { className: "white-space-default" },
              "Actual gearing"
            ),
            "\xA0",
            this.renderIcon("pdpDataPointActualGearing", 'Actual gearing'),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "span",
              { className: "disclaimer font-dark-gray", "data-testid": "fund-stats-actual-gearing-as-of-date", id: "fund-stats-actual-gearing-as-of-date" },
              _string_utility2.default.renderFormattedLabel('As of ', 'label-for-as-of', { role: this.props.role }),
              _date_formatter2.default.getLocalFormattedDate((0, _ramda.pathOr)(null, ["marketPrice", "date"], this.props))
            )
          ),
          _react2.default.createElement(
            "span",
            { className: "text-right col-xs-5 col-md-5 col-lg-4 col-xlg-5 float-right category",
              "data-testid": "fund-stats-actual-gearing", id: "fund-stats-actual-gearing" },
            (0, _ramda.isNil)(this.props.actualGearing) ? '-' : _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.actualGearing)
          )
        )
      );
    }
  }, {
    key: "renderData",
    value: function renderData() {
      var visibleFundFacts = this.props.visibleData.visibleFundFacts;

      var fundDataMarkup = [];

      var fundFactsMap = {
        "SEDOL": this.renderSedolCode,
        "ISIN": this.renderIsin,
        "APIR": this.renderAPIR,
        "TICKER": this.renderTicker,
        "IRESS_TICKER": this.renderIressTicker,
        "EXCHANGE_TICKER": this.renderExchangeTicker,
        "LISTING_DATE": this.renderListingDate,
        "DOMICILE": this.renderDomicile,
        "BLOOMBERG": this.renderBloomberg,
        "REUTERS_INSTRUMENT_CODE": this.renderReutersInstrumentCode,
        "VIIV_TICKER": this.renderVIIVTicker,
        "MMF_TYPE": this.renderMmfType,
        "ASSET_CLASS": this.renderAssetClass,
        "REGION_OF_INVESTMENT": this.renderRegionOfInvestment,
        "FUND_CURRENCY_CODE": this.renderFundCurrencyCode,
        "SHARECLASS_CURRENCY_CODE": this.renderShareclassCurrencyCode,
        "DATE_OF_AGREEMENT": this.renderDateOfAgreement,
        "FUND_INCEPTION_DATE": this.renderFundInceptionDate,
        "SHARE_CLASS_INCEPTION_DATE": this.renderShareClassInceptionDate,
        "ETF_INCEPTION_DATE": this.renderETFInceptionDate,
        "CUSIP": this.renderCusip,
        "SHARECLASS_CUT_OFF_TIME": this.renderShareClassCutOffTime,
        "FUND_CUT_OFF_TIME": this.renderFundCutOffTime,
        "SHARECLASS_NUMBER": this.renderShareclassNumber,
        "EXCHANGE": this.renderExchange,
        "DISTRIBUTION_FREQUENCY": this.renderDistributionFrequency,
        "DISTRIBUTION_DATE": this.renderDistributionDate,
        "LIQUIDATION_DATE": this.renderLiquidationDate,
        "NEWSPAPER_SHORTNAME": this.renderNewspaperShortName,
        "RISK": this.renderRisk,
        "BENCHMARK": this.renderBenchmark,
        "REDEMPTION_SETTLEMENT_DATE": this.renderRedemptionSettlementDate,
        "TRUSTEE": this.renderTrustee,
        "DEALING": this.renderDealing,
        "YEAR_END": this.renderYearEnd,
        "SHARE_CLASS_CURRENCY_HEDGING": this.renderCurrencyHedging,
        "FUND_VALUATION_DATE": this.renderFundValuationDate,
        "SHARE_CLASS_SETTLEMENT_DATE": this.renderShareclassSettlementDate,
        "FUND_LEGAL_STRUCTURE": this.renderFundLegalStructure,
        "VALOREN": this.renderValoren,
        "WKN": this.renderWKN,
        "FUND_COMPANY_NAME": this.renderFundCompanyName,
        "OFFER_PRICE": this.renderOfferPrice,
        "CUSTODIAN": this.renderCustodian,
        "TOTAL_ANNUAL_DIVIDEND": this.renderAnnualDividend,
        "POTENTIAL_GEARING_RANGE": this.renderPotentialGearingRange,
        "ACTUAL_GEARING": this.renderActualGearing,
        "COMPANY_BROKERS": this.renderCompanyBrokers,
        "ESG_APPROACH": this.renderEsgApproach,
        "DRP_DOC_LINK": this.renderDrpDocLink,
        "SFDR_CLASSIFICATION": this.renderSFDRClassification,
        "UK_SDR_CLASSIFICATION": this.renderUKSFDRClassification
      };

      for (var i = 0; (0, _ramda.complement)(_ramda.isNil)(visibleFundFacts) && i < visibleFundFacts.length; i++) {
        var fundFactRow = fundFactsMap[visibleFundFacts[i]]();
        if (fundFactRow !== null) {
          var backgroundRowColor = "row margin-vertical-0 margin-horizontal--30 padding-vertical-10 padding-horizontal-24 border-bottom-1 border-light-grey";
          fundDataMarkup.push(_react2.default.createElement(
            "div",
            { key: visibleFundFacts[i], className: "" + backgroundRowColor },
            _react2.default.createElement(
              "div",
              { className: "col-md-12 padding-left-0 padding-right-0 float-none" },
              fundFactRow
            )
          ));
        }
      }

      return fundDataMarkup;
    }
  }, {
    key: "getHeaderTitle",
    value: function getHeaderTitle(labelId) {
      return _string_utility2.default.renderFormattedLabel("Fund Facts", labelId, { fundType: (0, _functional_utility3.isNilOrEmpty)(this.props.fundTypeCode) ? "" : this.props.fundTypeCode.replace(/\s/g, ''), role: this.props.role });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _card_component2.default,
        {
          className: "print-full-width",
          dataTest: "fund-facts",
          headerTitle: this.getHeaderTitle("pdp-overview-fund-facts"),
          headerTitleId: "fund-facts-header",
          headerTitleLabel: "",
          headerLabel: "",
          disclosureText: this.props.disclosure.pdpCardFundFacts,
          placementId: "pdpCardFundFacts",
          displayStyle: 'width-percent-100 float-left margin-right-3',
          breakpoint: this.props.breakpoint,
          shouldAlwaysShowMore: this.props.shouldAlwaysShowMore,
          is25PercentCard: true
        },
        _react2.default.createElement(
          "div",
          { role: "table", "aria-labelledby": "fund-facts-header" },
          this.renderData()
        ),
        _react2.default.createElement(
          "div",
          { "data-testid": "cutoff-time-print-disclosure",
            className: "text-justified category print-display print-page-break", style: { "display": "none" } },
          this.renderCutOffTimeDisclosure()
        )
      );
    }
  }]);

  return FundFactsCard;
}(_react2.default.Component);

exports.default = FundFactsCard;